export type LookupCode = {
  rdsapVersion: string;
  dataItem: string;
  lookUpItem: string;
  customLookName: string;
  lookupValue: string;
  name?: string;
}

export const rdsapLookupCodes: LookupCode[] =
[
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "GlazingCoverage",
        "lookUpItem": "Typical",
        "customLookName": "Typical",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "GlazingCoverage",
        "lookUpItem": "More than typical",
        "customLookName": "More than typical",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "GlazingCoverage",
        "lookUpItem": "Less than typical",
        "customLookName": "Less than typical",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "GlazingCoverage",
        "lookUpItem": "Much more than typical",
        "customLookName": "Much more than typical",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "GlazingCoverage",
        "lookUpItem": "Much less than typical",
        "customLookName": "Much less than typical",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConservatoryType",
        "lookUpItem": "None",
        "customLookName": "None",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConservatoryType",
        "lookUpItem": "Separated, un-heated",
        "customLookName": "Separated, un-heated",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConservatoryType",
        "lookUpItem": "Separated, fixed heating",
        "customLookName": "Separated, fixed heating",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConservatoryType",
        "lookUpItem": "Non-separated",
        "customLookName": "Non-separated",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Glazing Type",
        "lookUpItem": "Double glazed (before 2002)",
        "customLookName": "Double glazed (before 2002)",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Glazing Type",
        "lookUpItem": "Double glazed (2002 or later)",
        "customLookName": "Double glazed (2002 or later)",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Glazing Type",
        "lookUpItem": "Double glazed (unknown age)",
        "customLookName": "Double glazed (unknown age)",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Glazing Type",
        "lookUpItem": "Secondary Glazing",
        "customLookName": "Secondary Glazing",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Glazing Type",
        "lookUpItem": "Single glazed",
        "customLookName": "Single glazed",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Glazing Type",
        "lookUpItem": "Triple glazed",
        "customLookName": "Triple glazed",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Glazing Type",
        "lookUpItem": "Double glazed, data known",
        "customLookName": "Double glazed, data known",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Glazing Type",
        "lookUpItem": "Triple glazed, data known",
        "customLookName": "Triple glazed, data known",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CountryCode",
        "lookUpItem": "England and Wales",
        "customLookName": "England and Wales",
        "lookupValue": "EAW",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CountryCode",
        "lookUpItem": "Scotland",
        "customLookName": "Scotland",
        "lookupValue": "SCT",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CountryCode",
        "lookUpItem": "Northern Ireland",
        "customLookName": "Northern Ireland",
        "lookupValue": "NIR",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TerrainType",
        "lookUpItem": "Dense Urban",
        "customLookName": "Dense Urban",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TerrainType",
        "lookUpItem": "Suburban",
        "customLookName": "Suburban",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TerrainType",
        "lookUpItem": "Rural",
        "customLookName": "Rural",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "DimensionsType",
        "lookUpItem": "Internal",
        "customLookName": "Internal",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "DimensionsType",
        "lookUpItem": "External",
        "customLookName": "External",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PropertyType",
        "lookUpItem": "House",
        "customLookName": "House",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PropertyType",
        "lookUpItem": "Bungalow",
        "customLookName": "Bungalow",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PropertyType",
        "lookUpItem": "Flat",
        "customLookName": "Flat",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PropertyType",
        "lookUpItem": "Maisonette",
        "customLookName": "Maisonette",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PropertyType",
        "lookUpItem": "Park Home",
        "customLookName": "Park Home",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "BuiltForm",
        "lookUpItem": "Detached",
        "customLookName": "Detached",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "BuiltForm",
        "lookUpItem": "Semi-detached",
        "customLookName": "Semi-detached",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "BuiltForm",
        "lookUpItem": "End-terrace",
        "customLookName": "End-terrace",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "BuiltForm",
        "lookUpItem": "Mid-terrace",
        "customLookName": "Mid-terrace",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "BuiltForm",
        "lookUpItem": "Enclosed end-terrace",
        "customLookName": "Enclosed end-terrace",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "BuiltForm",
        "lookUpItem": "Enclosed mid-terrace",
        "customLookName": "Enclosed mid-terrace",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConservatoryHeight",
        "lookUpItem": "1 storey",
        "customLookName": "1 storey",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConservatoryHeight",
        "lookUpItem": "1½ storeys",
        "customLookName": "1½ storeys",
        "lookupValue": "1.5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConservatoryHeight",
        "lookUpItem": "2 storeys",
        "customLookName": "2 storeys",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConservatoryHeight",
        "lookUpItem": "2½ storeys",
        "customLookName": "2½ storeys",
        "lookupValue": "2.5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConservatoryHeight",
        "lookUpItem": "3 storeys",
        "customLookName": "3 storeys",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Extensions",
        "lookUpItem": "None",
        "customLookName": "None",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Extensions",
        "lookUpItem": "1",
        "customLookName": "1",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Extensions",
        "lookUpItem": "2",
        "customLookName": "2",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Extensions",
        "lookUpItem": "3",
        "customLookName": "3",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Extensions",
        "lookUpItem": "4",
        "customLookName": "4",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallConstruction",
        "lookUpItem": "Stone (granite or whinstone)",
        "customLookName": "Stone (granite or whinstone)",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallConstruction",
        "lookUpItem": "Stone (sandstone or limestone)",
        "customLookName": "Stone (sandstone or limestone)",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallConstruction",
        "lookUpItem": "Solid Brick",
        "customLookName": "Solid Brick",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallConstruction",
        "lookUpItem": "Cavity",
        "customLookName": "Cavity",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallConstruction",
        "lookUpItem": "Timber frame",
        "customLookName": "Timber frame",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallConstruction",
        "lookUpItem": "System built",
        "customLookName": "System built",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallConstruction",
        "lookUpItem": "Cob",
        "customLookName": "Cob",
        "lookupValue": "9",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallConstruction",
        "lookUpItem": "Park Home",
        "customLookName": "Park Home",
        "lookupValue": "10",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PartyWallConstruction",
        "lookUpItem": "Unable to determine",
        "customLookName": "Unable to determine",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PartyWallConstruction",
        "lookUpItem": "Solid masonry, timber framed or system built",
        "customLookName": "Solid masonry, timber framed or system built",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PartyWallConstruction",
        "lookUpItem": "Masonry, cavity unfilled",
        "customLookName": "Masonry, cavity unfilled",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PartyWallConstruction",
        "lookUpItem": "Masonry, cavity filled",
        "customLookName": "Masonry, cavity filled",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PartyWallConstruction",
        "lookUpItem": "Not applicable",
        "customLookName": "Not applicable",
        "lookupValue": "NA",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulationPosition",
        "lookUpItem": "None",
        "customLookName": "None",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulationPosition",
        "lookUpItem": "External",
        "customLookName": "External",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulationPosition",
        "lookUpItem": "Internal",
        "customLookName": "Internal",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SolarPump",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SolarPump",
        "lookUpItem": "Electrically powered",
        "customLookName": "Electrically powered",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SolarPump",
        "lookUpItem": "PV powered",
        "customLookName": "PV powered",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "YESNO",
        "lookUpItem": "No",
        "customLookName": "No",
        "lookupValue": "N",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "YESNO",
        "lookUpItem": "Yes",
        "customLookName": "Yes",
        "lookupValue": "Y",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TRUEFALSE",
        "lookUpItem": "No",
        "customLookName": "No",
        "lookupValue": "FALSE",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TRUEFALSE",
        "lookUpItem": "Yes",
        "customLookName": "Yes",
        "lookupValue": "TRUE",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PVConnection",
        "lookUpItem": "NA",
        "customLookName": "NA",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PVConnection",
        "lookUpItem": "No",
        "customLookName": "No",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PVConnection",
        "lookUpItem": "Yes",
        "customLookName": "Yes",
        "lookupValue": "2",
    },
    {
      "rdsapVersion": "9.9.4",
      "dataItem": "FloorHeatloss",
      "lookUpItem": "Ground floor",
      "customLookName": "Ground floor",
      "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorHeatloss",
        "lookUpItem": "To external air",
        "customLookName": "To external air",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorHeatloss",
        "lookUpItem": "Above an unheated space",
        "customLookName": "Above an unheated space",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorHeatloss",
        "lookUpItem": "Above a partially heated space[commercial premises]",
        "customLookName": "Above a partially heated space[commercial premises]",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorHeatloss",
        "lookUpItem": "Another dwelling below",
        "customLookName": "Another dwelling below",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorHeatloss",
        "lookUpItem": "Same dwelling below",
        "customLookName": "Same dwelling below",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Flat Level",
        "lookUpItem": "Basement",
        "customLookName": "Basement",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Flat Level",
        "lookUpItem": "Ground Floor",
        "customLookName": "Ground Floor",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Flat Level",
        "lookUpItem": "Mid-Floor",
        "customLookName": "Mid-Floor",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Flat Level",
        "lookUpItem": "Top Floor",
        "customLookName": "Top Floor",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorConstruction",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorConstruction",
        "lookUpItem": "Solid",
        "customLookName": "Solid",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorConstruction",
        "lookUpItem": "Suspended, timber",
        "customLookName": "Suspended, timber",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorConstruction",
        "lookUpItem": "Suspended, not-timber",
        "customLookName": "Suspended, not-timber",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorInsulation",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorInsulation",
        "lookUpItem": "As-built",
        "customLookName": "As-built",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorInsulation",
        "lookUpItem": "Retro-fitted",
        "customLookName": "Retro-fitted",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorInsulationThickness",
        "lookUpItem": "50mm",
        "customLookName": "50mm",
        "lookupValue": "50mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorInsulationThickness",
        "lookUpItem": "100mm",
        "customLookName": "100mm",
        "lookupValue": "100mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorInsulationThickness",
        "lookUpItem": "150mm",
        "customLookName": "150mm",
        "lookupValue": "150mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FloorInsulationThickness",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "NI",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatlossCorridor",
        "lookUpItem": "None",
        "customLookName": "None",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatlossCorridor",
        "lookUpItem": "Heated",
        "customLookName": "Heated",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatlossCorridor",
        "lookUpItem": "Unheated",
        "customLookName": "Unheated",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "VentilationType",
        "lookUpItem": "Natural",
        "customLookName": "Natural",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "VentilationType",
        "lookUpItem": "Mechanical Ventilation, extract only",
        "customLookName": "Mechanical Ventilation, extract only",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "VentilationType",
        "lookUpItem": "Mechanical Ventilation, balanced",
        "customLookName": "Mechanical Ventilation, balanced",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlueAvailabilityCode",
        "lookUpItem": "N/A",
        "customLookName": "N/A",
        "lookupValue": "",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlueAvailabilityCode",
        "lookUpItem": "Open",
        "customLookName": "Open",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlueAvailabilityCode",
        "lookUpItem": "Balanced",
        "customLookName": "Balanced",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ElectricityMeter",
        "lookUpItem": "Single",
        "customLookName": "Single",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ElectricityMeter",
        "lookUpItem": "Dual",
        "customLookName": "Dual",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ElectricityMeter",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ElectricityMeter",
        "lookUpItem": "24 hour",
        "customLookName": "24 hour",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ElectricityMeter",
        "lookUpItem": "18 hour",
        "customLookName": "18 hour",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PumpAge",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PumpAge",
        "lookUpItem": "2012 or earlier",
        "customLookName": "2012 or earlier",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PumpAge",
        "lookUpItem": "2013 or later",
        "customLookName": "2013 or later",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlowTemp",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlowTemp",
        "lookUpItem": "> 45C",
        "customLookName": "> 45C",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlowTemp",
        "lookUpItem": "> 35C <= 45C",
        "customLookName": "> 35C <= 45C",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlowTemp",
        "lookUpItem": "<= 35C",
        "customLookName": "<= 35C",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlowTemp",
        "lookUpItem": "Not applicable",
        "customLookName": "Not applicable",
        "lookupValue": "NA",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderInsulationType",
        "lookUpItem": "None",
        "customLookName": "None",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderInsulationType",
        "lookUpItem": "Factory fitted",
        "customLookName": "Factory fitted",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderInsulationType",
        "lookUpItem": "Loose jacket",
        "customLookName": "Loose jacket",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderInsulationThickness",
        "lookUpItem": "12mm",
        "customLookName": "12mm",
        "lookupValue": "12",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderInsulationThickness",
        "lookUpItem": "25mm",
        "customLookName": "25mm",
        "lookupValue": "25",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderInsulationThickness",
        "lookUpItem": "38mm",
        "customLookName": "38mm",
        "lookupValue": "38",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderInsulationThickness",
        "lookUpItem": "50mm",
        "customLookName": "50mm",
        "lookupValue": "50",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderInsulationThickness",
        "lookUpItem": "80mm",
        "customLookName": "80mm",
        "lookupValue": "80",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderInsulationThickness",
        "lookUpItem": "120mm",
        "customLookName": "120mm",
        "lookupValue": "120",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderInsulationThickness",
        "lookUpItem": "160mm",
        "customLookName": "160mm",
        "lookupValue": "160",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ImmersionType",
        "lookUpItem": "Dual immersion",
        "customLookName": "Dual immersion",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ImmersionType",
        "lookUpItem": "Single immersion",
        "customLookName": "Single immersion",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlueType",
        "lookUpItem": "Open",
        "customLookName": "Open",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlueType",
        "lookUpItem": "Room-sealed",
        "customLookName": "Room-sealed",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TransactionType",
        "lookUpItem": "Marketed Sale",
        "customLookName": "Marketed Sale",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TransactionType",
        "lookUpItem": "Non-Marketed Sale",
        "customLookName": "Non-Marketed Sale",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TransactionType",
        "lookUpItem": "Stock condition survey",
        "customLookName": "Stock condition survey",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TransactionType",
        "lookUpItem": "Rental",
        "customLookName": "Rental",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TransactionType",
        "lookUpItem": "Assessment for Green Deal",
        "customLookName": "Assessment for Green Deal",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TransactionType",
        "lookUpItem": "Following Green Deal",
        "customLookName": "Following Green Deal",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TransactionType",
        "lookUpItem": "FiT application",
        "customLookName": "FiT application",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TransactionType",
        "lookUpItem": "RHI application",
        "customLookName": "RHI application",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TransactionType",
        "lookUpItem": "ECO assessment",
        "customLookName": "ECO assessment",
        "lookupValue": "9",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "TransactionType",
        "lookUpItem": "None of the above",
        "customLookName": "None of the above",
        "lookupValue": "10",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Tenure",
        "lookUpItem": "Owner-occupied",
        "customLookName": "Owner-occupied",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Tenure",
        "lookUpItem": "Rented (social)",
        "customLookName": "Rented (social)",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Tenure",
        "lookUpItem": "Rented (private)",
        "customLookName": "Rented (private)",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Tenure",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "ND",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WindowType",
        "lookUpItem": "Window",
        "customLookName": "Window",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WindowType",
        "lookUpItem": "Roof-window",
        "customLookName": "Roof-window",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Survey Language",
        "lookUpItem": "English",
        "customLookName": "English",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Survey Language",
        "lookUpItem": "Welsh",
        "customLookName": "Welsh",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Orientation",
        "lookUpItem": "North",
        "customLookName": "North",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Orientation",
        "lookUpItem": "North East",
        "customLookName": "North East",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Orientation",
        "lookUpItem": "East",
        "customLookName": "East",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Orientation",
        "lookUpItem": "South East",
        "customLookName": "South East",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Orientation",
        "lookUpItem": "South",
        "customLookName": "South",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Orientation",
        "lookUpItem": "South West",
        "customLookName": "South West",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Orientation",
        "lookUpItem": "West",
        "customLookName": "West",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Orientation",
        "lookUpItem": "North West",
        "customLookName": "North West",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Orientation",
        "lookUpItem": "Horizontal",
        "customLookName": "Horizontal",
        "lookupValue": "9",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "VerticalPitch",
        "lookUpItem": "Horizontal",
        "customLookName": "Horizontal",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "VerticalPitch",
        "lookUpItem": "30 degrees",
        "customLookName": "30 degrees",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "VerticalPitch",
        "lookUpItem": "45 degrees",
        "customLookName": "45 degrees",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "VerticalPitch",
        "lookUpItem": "60 degrees",
        "customLookName": "60 degrees",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "VerticalPitch",
        "lookUpItem": "Vertical",
        "customLookName": "Vertical",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Overshading",
        "lookUpItem": "None or very little",
        "customLookName": "None or very little",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Overshading",
        "lookUpItem": "Modest",
        "customLookName": "Modest",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Overshading",
        "lookUpItem": "Significant",
        "customLookName": "Significant",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Overshading",
        "lookUpItem": "Heavy",
        "customLookName": "Heavy",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CollectorType",
        "lookUpItem": "Unglazed",
        "customLookName": "Unglazed",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CollectorType",
        "lookUpItem": "Flat plate",
        "customLookName": "Flat plate",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CollectorType",
        "lookUpItem": "Evacuated tube",
        "customLookName": "Evacuated tube",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "None",
        "customLookName": "None",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Mains gas",
        "customLookName": "Mains gas",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "LPG",
        "customLookName": "LPG",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Bottled LPG",
        "customLookName": "Bottled LPG",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Oil",
        "customLookName": "Oil",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Anthracite",
        "customLookName": "Anthracite",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Wood logs",
        "customLookName": "Wood logs",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Bulk wood pellets",
        "customLookName": "Bulk wood pellets",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Wood chips",
        "customLookName": "Wood chips",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Dual fuel",
        "customLookName": "Dual fuel",
        "lookupValue": "9",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Electricity",
        "customLookName": "Electricity",
        "lookupValue": "10",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Waste combustion",
        "customLookName": "Waste combustion",
        "lookupValue": "11",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Biomass",
        "customLookName": "Biomass",
        "lookupValue": "12",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Biogas",
        "customLookName": "Biogas",
        "lookupValue": "13",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "House coal",
        "customLookName": "House coal",
        "lookupValue": "14",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Smokeless coal",
        "customLookName": "Smokeless coal",
        "lookupValue": "15",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Wood pellets in bags for secondary heating",
        "customLookName": "Wood pellets in bags for secondary heating",
        "lookupValue": "16",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "LPG special condition",
        "customLookName": "LPG special condition",
        "lookupValue": "17",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "B30K",
        "customLookName": "B30K",
        "lookupValue": "18",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Bioethanol",
        "customLookName": "Bioethanol",
        "lookupValue": "19",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Mains gas (community)",
        "customLookName": "Mains gas (community)",
        "lookupValue": "20",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "LPG (community)",
        "customLookName": "LPG (community)",
        "lookupValue": "21",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Oil (community)",
        "customLookName": "Oil (community)",
        "lookupValue": "22",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "B30D (community)",
        "customLookName": "B30D (community)",
        "lookupValue": "23",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Coal (community)",
        "customLookName": "Coal (community)",
        "lookupValue": "24",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Electricity (community)",
        "customLookName": "Electricity (community)",
        "lookupValue": "25",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Mains gas",
        "customLookName": "Mains gas",
        "lookupValue": "26",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "LPG",
        "customLookName": "LPG",
        "lookupValue": "27",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Oil",
        "customLookName": "Oil",
        "lookupValue": "28",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Electricity (not community)",
        "customLookName": "Electricity (not community)",
        "lookupValue": "29",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Waste combustion (community)",
        "customLookName": "Waste combustion (community)",
        "lookupValue": "30",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Biomass (community)",
        "customLookName": "Biomass (community)",
        "lookupValue": "31",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Biogas (community)",
        "customLookName": "Biogas (community)",
        "lookupValue": "32",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "House coal",
        "customLookName": "House coal",
        "lookupValue": "33",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Biodiesel from any biomass source",
        "customLookName": "Biodiesel from any biomass source",
        "lookupValue": "34",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Biodiesel from used cooking oil only",
        "customLookName": "Biodiesel from used cooking oil only",
        "lookupValue": "35",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Biodiesel from vegetable oil only",
        "customLookName": "Biodiesel from vegetable oil only",
        "lookupValue": "36",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Mineral oil or liquid biofuel",
        "customLookName": "Mineral oil or liquid biofuel",
        "lookupValue": "37",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Biogas",
        "customLookName": "Biogas",
        "lookupValue": "51",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Heat from boilers that can use mineral oil or biodiesel (community)",
        "customLookName": "Heat from boilers that can use mineral oil or biodiesel (community)",
        "lookupValue": "56",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Heat from boilers using biodiesel from any biomass source (community)",
        "customLookName": "Heat from boilers using biodiesel from any biomass source (community)",
        "lookupValue": "57",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Biodiesel from vegetable oil only (community)",
        "customLookName": "Biodiesel from vegetable oil only (community)",
        "lookupValue": "58",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "From heat network data (community)",
        "customLookName": "From heat network data (community)",
        "lookupValue": "99",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Community - Coal",
        "customLookName": "Community - Coal",
        "lookupValue": "24",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Community - Electricity",
        "customLookName": "Community - Electricity",
        "lookupValue": "25",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Community - Waste combustion",
        "customLookName": "Community - Waste combustion",
        "lookupValue": "30",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Community - Biomass",
        "customLookName": "Community - Biomass",
        "lookupValue": "31",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Community - Biogas",
        "customLookName": "Community - Biogas",
        "lookupValue": "32",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Community - Power station waste",
        "customLookName": "Community - Power station waste",
        "lookupValue": "56",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Community - Geothermal",
        "customLookName": "Community - Geothermal",
        "lookupValue": "57",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Community CHP - Heat",
        "customLookName": "Community CHP - Heat",
        "lookupValue": "58",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Community CHP - Electricity",
        "customLookName": "Community CHP - Electricity",
        "lookupValue": "99",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SapFuels",
        "lookUpItem": "Community - Electricity dnet?",
        "customLookName": "Community - Electricity dnet?",
        "lookupValue": "99",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WindowDataSource",
        "lookUpItem": "Manufacturer",
        "customLookName": "Manufacturer",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WindowDataSource",
        "lookUpItem": "BFRC",
        "customLookName": "BFRC",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "GlazingGap",
        "lookUpItem": "6mm",
        "customLookName": "6mm",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "GlazingGap",
        "lookUpItem": "12mm",
        "customLookName": "12mm",
        "lookupValue": "12",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "GlazingGap",
        "lookUpItem": "16mm+",
        "customLookName": "16mm+",
        "lookupValue": "16+",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ShowerType",
        "lookUpItem": "Non-electric only",
        "customLookName": "Non-electric only",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ShowerType",
        "lookUpItem": "Electric only",
        "customLookName": "Electric only",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ShowerType",
        "lookUpItem": "Both electric and non-electric",
        "customLookName": "Both electric and non-electric",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ShowerType",
        "lookUpItem": "No shower",
        "customLookName": "No shower",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Loft Insulation",
        "customLookName": "Loft Insulation",
        "lookupValue": "A",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Flat roof insulation",
        "customLookName": "Flat roof insulation",
        "lookupValue": "A2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Room-in-roof insulation",
        "customLookName": "Room-in-roof insulation",
        "lookupValue": "A3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Cavity wall insulation",
        "customLookName": "Cavity wall insulation",
        "lookupValue": "B",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Party wall insulation",
        "customLookName": "Party wall insulation",
        "lookupValue": "B4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Hot water cylinder insulation",
        "customLookName": "Hot water cylinder insulation",
        "lookupValue": "C",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Draughtproofing",
        "customLookName": "Draughtproofing",
        "lookupValue": "D",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Low energy lights",
        "customLookName": "Low energy lights",
        "lookupValue": "E",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Cylinder thermostat",
        "customLookName": "Cylinder thermostat",
        "lookupValue": "F",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Heating controls for wet central heating system",
        "customLookName": "Heating controls for wet central heating system",
        "lookupValue": "G",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Water heating controls",
        "customLookName": "Water heating controls",
        "lookupValue": "G2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Heating controls for warm air system",
        "customLookName": "Heating controls for warm air system",
        "lookupValue": "H",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Upgrade boiler, same fuel",
        "customLookName": "Upgrade boiler, same fuel",
        "lookupValue": "I",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Biomass boiler",
        "customLookName": "Biomass boiler",
        "lookupValue": "J",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Biomass boiler as alternative improvement",
        "customLookName": "Biomass boiler as alternative improvement",
        "lookupValue": "J2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Biomass room heater with boiler",
        "customLookName": "Biomass room heater with boiler",
        "lookupValue": "K",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "New or replacement fan-assisted storage heaters",
        "customLookName": "New or replacement fan-assisted storage heaters",
        "lookupValue": "L",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "New or replacement high heat retention storage heaters",
        "customLookName": "New or replacement high heat retention storage heaters",
        "lookupValue": "L2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Replacement warm-air unit",
        "customLookName": "Replacement warm-air unit",
        "lookupValue": "M",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Solar water heating",
        "customLookName": "Solar water heating",
        "lookupValue": "N",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Replacement double glazed windows",
        "customLookName": "Replacement double glazed windows",
        "lookupValue": "O",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Replacement double glazing units",
        "customLookName": "Replacement double glazing units",
        "lookupValue": "O3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Secondary glazing",
        "customLookName": "Secondary glazing",
        "lookupValue": "P",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Solid wall insulation",
        "customLookName": "Solid wall insulation",
        "lookupValue": "Q",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "External insulation with cavity wall insulation",
        "customLookName": "External insulation with cavity wall insulation",
        "lookupValue": "Q2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Condensing oil boiler",
        "customLookName": "Condensing oil boiler",
        "lookupValue": "R",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Change heating to Band A gas condensing boiler (no fuel switch)",
        "customLookName": "Change heating to Band A gas condensing boiler (no fuel switch)",
        "lookupValue": "S",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Change heating to Band A gas condensing boiler (fuel switch)",
        "customLookName": "Change heating to Band A gas condensing boiler (fuel switch)",
        "lookupValue": "T",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Flue gas heat recovery",
        "customLookName": "Flue gas heat recovery",
        "lookupValue": "T2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Photovoltaics",
        "customLookName": "Photovoltaics",
        "lookupValue": "U",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "PV Battery",
        "customLookName": "PV Battery",
        "lookupValue": "U1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "PV Diverter",
        "customLookName": "PV Diverter",
        "lookupValue": "U2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Wind turbine (roof mounted)",
        "customLookName": "Wind turbine (roof mounted)",
        "lookupValue": "V",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Wind turbine (on mast)",
        "customLookName": "Wind turbine (on mast)",
        "lookupValue": "V2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Floor insulation; for backwards compatibility only, do not use",
        "customLookName": "Floor insulation; for backwards compatibility only, do not use",
        "lookupValue": "W",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Insulation of suspended floor",
        "customLookName": "Insulation of suspended floor",
        "lookupValue": "W1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Insulation of solid ground floor",
        "customLookName": "Insulation of solid ground floor",
        "lookupValue": "W2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Insulated doors",
        "customLookName": "Insulated doors",
        "lookupValue": "X",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Instantaneous waste water heat recovery",
        "customLookName": "Instantaneous waste water heat recovery",
        "lookupValue": "Y",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Storage waste water heat recovery",
        "customLookName": "Storage waste water heat recovery",
        "lookupValue": "Y2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Air or ground source heat pump",
        "customLookName": "Air or ground source heat pump",
        "lookupValue": "Z1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Air or ground source heat pump with underfloor heating",
        "customLookName": "Air or ground source heat pump with underfloor heating",
        "lookupValue": "Z2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Micro-CHP",
        "customLookName": "Micro-CHP",
        "lookupValue": "Z3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Recommendation",
        "lookUpItem": "Not recorded",
        "customLookName": "Not recorded",
        "lookupValue": "NR",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RelatedParty",
        "lookUpItem": "No related party",
        "customLookName": "No related party",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RelatedParty",
        "lookUpItem": "Relative of homeowner or of occupier of the property",
        "customLookName": "Relative of homeowner or of occupier of the property",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RelatedParty",
        "lookUpItem": "Residing at the property",
        "customLookName": "Residing at the property",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RelatedParty",
        "lookUpItem": "Financial interest in the property",
        "customLookName": "Financial interest in the property",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RelatedParty",
        "lookUpItem": "Owner or Director of the organisation dealing with the property transaction",
        "customLookName": "Owner or Director of the organisation dealing with the property transaction",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RelatedParty",
        "lookUpItem": "Employed by the professional dealing with the property transaction",
        "customLookName": "Employed by the professional dealing with the property transaction",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RelatedParty",
        "lookUpItem": "Relative of the professional dealing with the property transaction",
        "customLookName": "Relative of the professional dealing with the property transaction",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Addenda",
        "lookUpItem": "1. Wall type does not correspond to options available in RdSAP",
        "customLookName": "1. Wall type does not correspond to options available in RdSAP",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Addenda",
        "lookUpItem": "2. Room heater specified for water heating instead of a range cooke",
        "customLookName": "2. Room heater specified for water heating instead of a range cooke",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Addenda",
        "lookUpItem": "3. Space heating from individual system and water heating from community system",
        "customLookName": "3. Space heating from individual system and water heating from community system",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Addenda",
        "lookUpItem": "4. Dwelling has a swimming pool",
        "customLookName": "4. Dwelling has a swimming pool",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Addenda",
        "lookUpItem": "5. Dwelling has micro-CHP not found in database",
        "customLookName": "5. Dwelling has micro-CHP not found in database",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Addenda",
        "lookUpItem": "6. Storage heater or dual immersion, and single electric meter",
        "customLookName": "6. Storage heater or dual immersion, and single electric meter",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Addenda",
        "lookUpItem": "7. Heating controlled by TRVs only",
        "customLookName": "7. Heating controlled by TRVs only",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Addenda",
        "lookUpItem": "8. PVs or wind turbine present on the property (England, Wales or Scotland)",
        "customLookName": "8. PVs or wind turbine present on the property (England, Wales or Scotland)",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Addenda",
        "lookUpItem": "9. Two main heating systems and heating system upgrade is recommended",
        "customLookName": "9. Two main heating systems and heating system upgrade is recommended",
        "lookupValue": "9",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Addenda",
        "lookUpItem": "10. Dual electricity meter selected but there is also an electricity meter for standard tariff",
        "customLookName": "10. Dual electricity meter selected but there is also an electricity meter for standard tariff",
        "lookupValue": "10",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Addenda",
        "lookUpItem": "11. Single electricity meter selected but there is also an electricity meter for an off-peak tariff",
        "customLookName": "11. Single electricity meter selected but there is also an electricity meter for an off-peak tariff",
        "lookupValue": "11",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Addenda",
        "lookUpItem": "12. Dwelling is using a biomass fuel that is not in the RdSAP fuel options",
        "customLookName": "12. Dwelling is using a biomass fuel that is not in the RdSAP fuel options",
        "lookupValue": "12",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Addenda",
        "lookUpItem": "13. Park Home",
        "customLookName": "13. Park Home",
        "lookupValue": "13",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WindowTransmissionDataSource",
        "lookUpItem": "Manufacturer",
        "customLookName": "Manufacturer",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WindowTransmissionDataSource",
        "lookUpItem": "BFRC",
        "customLookName": "BFRC",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulation",
        "lookUpItem": "As built",
        "customLookName": "As built",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulation",
        "lookUpItem": "Internal",
        "customLookName": "Internal",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulation",
        "lookUpItem": "External",
        "customLookName": "External",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulation",
        "lookUpItem": "Filled cavity",
        "customLookName": "Filled cavity",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulation",
        "lookUpItem": "Filled cavity and internal",
        "customLookName": "Filled cavity and internal",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulation",
        "lookUpItem": "Filled cavity and external",
        "customLookName": "Filled cavity and external",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulation",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofConstruction",
        "lookUpItem": "Flat roof",
        "customLookName": "Flat roof",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofConstruction",
        "lookUpItem": "Another dwelling above",
        "customLookName": "Another dwelling above",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofConstruction",
        "lookUpItem": "Pitched (slates or tiles), access to loft",
        "customLookName": "Pitched (slates or tiles), access to loft",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofConstruction",
        "lookUpItem": "Pitched (slates or tiles), no loft access",
        "customLookName": "Pitched (slates or tiles), no loft access",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofConstruction",
        "lookUpItem": "Pitched (thatched)",
        "customLookName": "Pitched (thatched)",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofConstruction",
        "lookUpItem": "Same dwelling above",
        "customLookName": "Same dwelling above",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofConstruction",
        "lookUpItem": "Pitched, sloping ceiling",
        "customLookName": "Pitched, sloping ceiling",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulationThickness",
        "lookUpItem": "50mm",
        "customLookName": "50mm",
        "lookupValue": "50mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulationThickness",
        "lookUpItem": "100mm",
        "customLookName": "100mm",
        "lookupValue": "100mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulationThickness",
        "lookUpItem": "150mm",
        "customLookName": "150mm",
        "lookupValue": "150mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulationThickness",
        "lookUpItem": "200mm",
        "customLookName": "200mm",
        "lookupValue": "200mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WallInsulationThickness",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "NI",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationLocation",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationLocation",
        "lookUpItem": "None",
        "customLookName": "None",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationLocation",
        "lookUpItem": "At joists",
        "customLookName": "At joists",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationLocation",
        "lookUpItem": "At rafters",
        "customLookName": "At rafters",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationLocation",
        "lookUpItem": "Flat roof insulation",
        "customLookName": "Flat roof insulation",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationLocation",
        "lookUpItem": "Sloping ceiling insulation",
        "customLookName": "Sloping ceiling insulation",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "NI",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "None",
        "customLookName": "None",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "As built",
        "customLookName": "As built",
        "lookupValue": "AB",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "12mm",
        "customLookName": "12mm",
        "lookupValue": "12mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "25mm",
        "customLookName": "25mm",
        "lookupValue": "25mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "50mm",
        "customLookName": "50mm",
        "lookupValue": "50mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "75mm",
        "customLookName": "75mm",
        "lookupValue": "75mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "100mm",
        "customLookName": "100mm",
        "lookupValue": "100mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "150mm",
        "customLookName": "150mm",
        "lookupValue": "150mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "150mm+",
        "customLookName": "150mm+",
        "lookupValue": "150mm+",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "200mm",
        "customLookName": "200mm",
        "lookupValue": "200mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "250mm",
        "customLookName": "250mm",
        "lookupValue": "250mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "270mm",
        "customLookName": "270mm",
        "lookupValue": "270mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "300mm",
        "customLookName": "300mm",
        "lookupValue": "300mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "350mm",
        "customLookName": "350mm",
        "lookupValue": "350mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofInsulationThickness",
        "lookUpItem": "400mm+",
        "customLookName": "400mm+",
        "lookupValue": "400mm+",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomInsulationType",
        "lookUpItem": "As built",
        "customLookName": "As built",
        "lookupValue": "AB",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomInsulationType",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomInsulationType",
        "lookUpItem": "Flat ceiling only",
        "customLookName": "Flat ceiling only",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomInsulationType",
        "lookUpItem": "All elements (except Flat ceiling) 50mm",
        "customLookName": "All elements (50mm)",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomInsulationType",
        "lookUpItem": "All elements (except Flat ceiling) 100mm",
        "customLookName": "All elements (100mm)",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomInsulationType",
        "lookUpItem": "All elements (except Flat ceiling) 150mm",
        "customLookName": "All elements (150mm)",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomInsulationType",
        "lookUpItem": "All elements insulation thickness unknown",
        "customLookName": "All elements (unknown)",
        "lookupValue": "NI",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "Not applicable",
        "customLookName": "Not applicable",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "Unknown",
        "customLookName": "Unknown",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "None",
        "customLookName": "None",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "12mm",
        "customLookName": "12mm",
        "lookupValue": "12mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "25mm",
        "customLookName": "25mm",
        "lookupValue": "25mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "50mm",
        "customLookName": "50mm",
        "lookupValue": "50mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "75mm",
        "customLookName": "75mm",
        "lookupValue": "75mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "100mm",
        "customLookName": "100mm",
        "lookupValue": "100mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "150mm",
        "customLookName": "150mm",
        "lookupValue": "150mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "200mm",
        "customLookName": "200mm",
        "lookupValue": "200mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "250mm",
        "customLookName": "250mm",
        "lookupValue": "250mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "270mm",
        "customLookName": "270mm",
        "lookupValue": "270mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "300mm",
        "customLookName": "300mm",
        "lookupValue": "300mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "350mm",
        "customLookName": "350mm",
        "lookupValue": "350mm",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "RoofRoomsInsulationThickness(AtCeiling)",
        "lookUpItem": "400mm+",
        "customLookName": "400mm+",
        "lookupValue": "400mm+",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PrimarySystemType",
        "lookUpItem": "SAP Default",
        "customLookName": "SAP Default",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "PrimarySystemType",
        "lookUpItem": "Database",
        "customLookName": "Database",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Community heating",
        "customLookName": "Community heating",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Electric underfloor",
        "customLookName": "Electric underfloor",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Warm air",
        "customLookName": "Warm air",
        "lookupValue": "9",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Room heaters",
        "customLookName": "Room heaters",
        "lookupValue": "10",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Other heating",
        "customLookName": "Other heating",
        "lookupValue": "11",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Gas boilers (including LPG) 1998 or later",
        "customLookName": "Gas boilers (including LPG) 1998 or later",
        "lookupValue": "145",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Gas boilers (including LPG) pre-1998, with fan-assisted flue",
        "customLookName": "Gas boilers (including LPG) pre-1998, with fan-assisted flue",
        "lookupValue": "146",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Gas boilers (including LPG) pre-1998, with balanced or open flue",
        "customLookName": "Gas boilers (including LPG) pre-1998, with balanced or open flue",
        "lookupValue": "147",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Gas-fired warm air with fan-assisted flue",
        "customLookName": "Gas-fired warm air with fan-assisted flue",
        "lookupValue": "150",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Gas fired warm air with balanced or open flue",
        "customLookName": "Gas fired warm air with balanced or open flue",
        "lookupValue": "151",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Range cooker boilers (mains gas and LPG)",
        "customLookName": "Range cooker boilers (mains gas and LPG)",
        "lookupValue": "149",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Oil boilers",
        "customLookName": "Oil boilers",
        "lookupValue": "248",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Oil-fired warm air",
        "customLookName": "Oil-fired warm air",
        "lookupValue": "250",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Range cooker boilers (oil)",
        "customLookName": "Range cooker boilers (oil)",
        "lookupValue": "249",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Heat pump with radiators or underfloor heating",
        "customLookName": "Heat pump with radiators or underfloor heating",
        "lookupValue": "253",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Heat pump with warm air distribution",
        "customLookName": "Heat pump with warm air distribution",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Electric boilers",
        "customLookName": "Electric boilers",
        "lookupValue": "251",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Electric storage systems",
        "customLookName": "Electric storage systems",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Electric underfloor heating",
        "customLookName": "Electric underfloor heating",
        "lookupValue": "373",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Electric warm air",
        "customLookName": "Electric warm air",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Electric (direct acting) room heaters",
        "customLookName": "Electric (direct acting) room heaters",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Other space heating systems",
        "customLookName": "Other space heating systems",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Oil room heaters",
        "customLookName": "Oil room heaters",
        "lookupValue": "252",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Combined Primary Storage Units (CPSU) (mains gas and LPG)",
        "customLookName": "Combined Primary Storage Units (CPSU) (mains gas and LPG)",
        "lookupValue": "148",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Gas (including LPG) room heaters",
        "customLookName": "Gas (including LPG) room heaters",
        "lookupValue": "152",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Solid fuel boilers",
        "customLookName": "Solid fuel boilers",
        "lookupValue": "240",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Solid fuel room heaters",
        "customLookName": "Solid fuel room heaters",
        "lookupValue": "241",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Community Heating Schemes",
        "customLookName": "Community Heating Schemes",
        "lookupValue": "426",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "Boiler",
        "customLookName": "Boiler",
        "lookupValue": "234",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingType",
        "lookUpItem": "HeatPump",
        "customLookName": "HeatPump",
        "lookupValue": "233",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Mains Gas",
        "customLookName": "Mains Gas",
        "lookupValue": "26",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Electricity",
        "customLookName": "Electricity",
        "lookupValue": "29",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Bulk LPG",
        "customLookName": "Bulk LPG",
        "lookupValue": "27",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Bottled LPG",
        "customLookName": "Bottled LPG",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Oil",
        "customLookName": "Oil",
        "lookupValue": "28",
    },{
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Bioethanol from biomass",
        "customLookName": "Bioethanol from biomass",
        "lookupValue": "402",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "House coal",
        "customLookName": "House coal",
        "lookupValue": "33",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Biodiesel (biomass)",
        "customLookName": "Biodiesel (biomass)",
        "lookupValue": "34",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Biodiesel (cooking oil)",
        "customLookName": "Biodiesel (cooking oil)",
        "lookupValue": "35",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Biodiesel (vegetable oil)",
        "customLookName": "Biodiesel (vegetable oil)",
        "lookupValue": "36",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Mineral oil/liquid biofuel",
        "customLookName": "Mineral oil/liquid biofuel",
        "lookupValue": "37",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Biogas",
        "customLookName": "Biogas",
        "lookupValue": "51",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Bioethanol",
        "customLookName": "Bioethanol",
        "lookupValue": "19",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "LPG special condition",
        "customLookName": "LPG special condition",
        "lookupValue": "17",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "B30K",
        "customLookName": "B30K",
        "lookupValue": "18",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Anthracite",
        "customLookName": "Anthracite",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Wood logs",
        "customLookName": "Wood logs",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Bulk wood pellets",
        "customLookName": "Bulk wood pellets",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Wood chips",
        "customLookName": "Wood chips",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Duel fuel (mineral + wood)",
        "customLookName": "Duel fuel (mineral + wood)",
        "lookupValue": "9",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Smokeless coal",
        "customLookName": "Smokeless coal",
        "lookupValue": "15",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Mains gas (community heating)",
        "customLookName": "Mains gas (community heating)",
        "lookupValue": "20",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Electricity (community heating)",
        "customLookName": "Electricity (community heating)",
        "lookupValue": "25",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "LPG (community heating)",
        "customLookName": "LPG (community heating)",
        "lookupValue": "21",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Oil (community heating)",
        "customLookName": "Oil (community heating)",
        "lookupValue": "22",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "B30D (community heating)",
        "customLookName": "B30D (community heating)",
        "lookupValue": "23",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Coal (community heating)",
        "customLookName": "Coal (community heating)",
        "lookupValue": "24",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Waste combustion (community heating)",
        "customLookName": "Waste combustion (community heating)",
        "lookupValue": "30",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Biomass (community heating)",
        "customLookName": "Biomass (community heating)",
        "lookupValue": "31",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Biogas (community heating)",
        "customLookName": "Biogas (community heating)",
        "lookupValue": "32",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Mineral / biodiesel (community heating)",
        "customLookName": "Mineral / biodiesel (community heating)",
        "lookupValue": "56",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Biodiesel from biomass source (community heating)",
        "customLookName": "Biodiesel from biomass source (community heating)",
        "lookupValue": "57",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "Biodiesel from vegetable oil (community heating)",
        "customLookName": "Biodiesel from vegetable oil (community heating)",
        "lookupValue": "58",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuel",
        "lookUpItem": "From heat network data (community heating)",
        "customLookName": "From heat network data (community heating)",
        "lookupValue": "99",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Manual feed independent boiler in heated space",
        "customLookName": "Manual feed independent boiler in heated space",
        "lookupValue": "151",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Manual feed independent boiler in unheated space",
        "customLookName": "Manual feed independent boiler in unheated space",
        "lookupValue": "152",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Auto (gravity) feed independent boiler in heated space",
        "customLookName": "Auto (gravity) feed independent boiler in heated space",
        "lookupValue": "153",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Auto (gravity) feed independent boiler in unheated space",
        "customLookName": "Auto (gravity) feed independent boiler in unheated space",
        "lookupValue": "154",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Wood chip/pellet independent boiler",
        "customLookName": "Wood chip/pellet independent boiler",
        "lookupValue": "155",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Open fire with back boiler to radiators",
        "customLookName": "Open fire with back boiler to radiators",
        "lookupValue": "156",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Closed room heater with boiler to radiators",
        "customLookName": "Closed room heater with boiler to radiators",
        "lookupValue": "158",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Stove (pellet-fired) with boiler to radiators",
        "customLookName": "Stove (pellet-fired) with boiler to radiators",
        "lookupValue": "159",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Range cooker boiler (integral oven and boiler)",
        "customLookName": "Range cooker boiler (integral oven and boiler)",
        "lookupValue": "160",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Direct-acting electric boiler",
        "customLookName": "Direct-acting electric boiler",
        "lookupValue": "191",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Electric water storage boiler",
        "customLookName": "Electric water storage boiler",
        "lookupValue": "195",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Electric CPSU",
        "customLookName": "Electric CPSU",
        "lookupValue": "192",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Electric dry core storage boiler",
        "customLookName": "Electric dry core storage boiler",
        "lookupValue": "193",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Single burner",
        "customLookName": "Single burner",
        "lookupValue": "139",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Twin burner (non-condensing), pre-1998",
        "customLookName": "Twin burner (non-condensing), pre-1998",
        "lookupValue": "140",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Single burner with permanent pilot",
        "customLookName": "Single burner with permanent pilot",
        "lookupValue": "133",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Single burner with automatic ignition",
        "customLookName": "Single burner with automatic ignition",
        "lookupValue": "134",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Twin burner with automatic ignition (non-condensing), pre-1998",
        "customLookName": "Twin burner with automatic ignition (non-condensing), pre-1998",
        "lookupValue": "136",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Standard oil boiler, pre-1998",
        "customLookName": "Standard oil boiler, pre-1998",
        "lookupValue": "125",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Standard oil boiler, 1998 or later",
        "customLookName": "Standard oil boiler, 1998 or later",
        "lookupValue": "126",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Standard Condensing",
        "customLookName": "Standard Condensing",
        "lookupValue": "127",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Combi, pre-1998",
        "customLookName": "Combi, pre-1998",
        "lookupValue": "128",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Combi, 1998 or later",
        "customLookName": "Combi, 1998 or later",
        "lookupValue": "129",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Condensing Combi",
        "customLookName": "Condensing Combi",
        "lookupValue": "130",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Oil room heater with boiler to radiator, pre-2000",
        "customLookName": "Oil room heater with boiler to radiator, pre-2000",
        "lookupValue": "131",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Oil room heater with boiler to radiators, 2000 or later",
        "customLookName": "Oil room heater with boiler to radiators, 2000 or later",
        "lookupValue": "132",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "With automatic ignition (non-condensing)",
        "customLookName": "With automatic ignition (non-condensing)",
        "lookupValue": "120",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "With automatic ignition (condensing)",
        "customLookName": "With automatic ignition (condensing)",
        "lookupValue": "121",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Regular non-condensing with automatic ignition",
        "customLookName": "Regular non-condensing with automatic ignition",
        "lookupValue": "101",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Regular condensing with automatic ignition",
        "customLookName": "Regular condensing with automatic ignition",
        "lookupValue": "102",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Non-condensing combi with automatic ignition",
        "customLookName": "Non-condensing combi with automatic ignition",
        "lookupValue": "103",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Condensing combi with automatic ignition",
        "customLookName": "Condensing combi with automatic ignition",
        "lookupValue": "104",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Regular non-condensing with permanent pilot light",
        "customLookName": "Regular non-condensing with permanent pilot light",
        "lookupValue": "105",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Non-condensing combi with permanent pilot light",
        "customLookName": "Non-condensing combi with permanent pilot light",
        "lookupValue": "107",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Back boiler to radiators",
        "customLookName": "Back boiler to radiators",
        "lookupValue": "109",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Regular boiler",
        "customLookName": "Regular boiler",
        "lookupValue": "111",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Combi boiler",
        "customLookName": "Combi boiler",
        "lookupValue": "112",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Condensing Combi boiler",
        "customLookName": "Condensing Combi boiler",
        "lookupValue": "113",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Condensing Regular boiler",
        "customLookName": "Condensing Regular boiler",
        "lookupValue": "114",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Regular, wall mounted",
        "customLookName": "Regular, wall mounted",
        "lookupValue": "115",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Regular, floor mounted, pre-1979",
        "customLookName": "Regular, floor mounted, pre-1979",
        "lookupValue": "116",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Regular, floor mounted, 1979-1997",
        "customLookName": "Regular, floor mounted, 1979-1997",
        "lookupValue": "117",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Combi",
        "customLookName": "Combi",
        "lookupValue": "118",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Back boiler to radiators",
        "customLookName": "Back boiler to radiators",
        "lookupValue": "119",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Air source heat pump with flow temperature <= 35°C",
        "customLookName": "Air source heat pump with flow temperature <= 35°C",
        "lookupValue": "214",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Ground source heat pump with flow temperature <= 35°C",
        "customLookName": "Ground source heat pump with flow temperature <= 35°C",
        "lookupValue": "211",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Water source heat pump with flow temperature <= 35°C",
        "customLookName": "Water source heat pump with flow temperature <= 35°C",
        "lookupValue": "213",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Air source heat pump, in other cases",
        "customLookName": "Air source heat pump, in other cases",
        "lookupValue": "224",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Ground source heat pump, in other cases",
        "customLookName": "Ground source heat pump, in other cases",
        "lookupValue": "221",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Water source heat pump, in other cases",
        "customLookName": "Water source heat pump, in other cases",
        "lookupValue": "223",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Air source heat pump with flow temperature <= 35°C",
        "customLookName": "Air source heat pump with flow temperature <= 35°C",
        "lookupValue": "217",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Ground source heat pump with flow temperature <= 35°C",
        "customLookName": "Ground source heat pump with flow temperature <= 35°C",
        "lookupValue": "215",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Water source heat pump with flow temperature <= 35°C",
        "customLookName": "Water source heat pump with flow temperature <= 35°C",
        "lookupValue": "216",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Air source heat pump, in other cases",
        "customLookName": "Air source heat pump, in other cases",
        "lookupValue": "227",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Ground source heat pump, in other cases",
        "customLookName": "Ground source heat pump, in other cases",
        "lookupValue": "225",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Water source heat pump, in other cases",
        "customLookName": "Water source heat pump, in other cases",
        "lookupValue": "226",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Community boilers",
        "customLookName": "Community boilers",
        "lookupValue": "301",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Community CHP and boilers",
        "customLookName": "Community CHP and boilers",
        "lookupValue": "302",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Community heat pump",
        "customLookName": "Community heat pump",
        "lookupValue": "304",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Community database heat network",
        "customLookName": "Community database heat network",
        "lookupValue": "310",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "In concrete slab (off-peak)",
        "customLookName": "In concrete slab (off-peak)",
        "lookupValue": "421",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Integrated (storage+direct-acting)",
        "customLookName": "Integrated (storage+direct-acting)",
        "lookupValue": "422",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "In screed above insulation",
        "customLookName": "In screed above insulation",
        "lookupValue": "424",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Old (large volume) storage heaters",
        "customLookName": "Old (large volume) storage heaters",
        "lookupValue": "401",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Slimline storage heaters",
        "customLookName": "Slimline storage heaters",
        "lookupValue": "402",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Fan storage heaters",
        "customLookName": "Fan storage heaters",
        "lookupValue": "404",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Integrated storage+direct-acting heater",
        "customLookName": "Integrated storage+direct-acting heater",
        "lookupValue": "408",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "High-heat retention storage heater",
        "customLookName": "High-heat retention storage heater",
        "lookupValue": "409",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Air source heat pump",
        "customLookName": "Air source heat pump",
        "lookupValue": "524",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Ducted or sub-ducted, on-off control, pre-1998",
        "customLookName": "Ducted or sub-ducted, on-off control, pre-1998",
        "lookupValue": "506",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Ducted or sub-ducted, modulated control, 1998 or later",
        "customLookName": "Ducted or sub-ducted, modulated control, 1998 or later",
        "lookupValue": "510",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Condensing",
        "customLookName": "Condensing",
        "lookupValue": "511",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Ducted output (on/off control)",
        "customLookName": "Ducted output (on/off control)",
        "lookupValue": "512",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Ducted, on-off control, 1998 or later",
        "customLookName": "Ducted, on-off control, 1998 or later",
        "lookupValue": "502",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Electricaire system",
        "customLookName": "Electricaire system",
        "lookupValue": "515",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Ground source heat pump",
        "customLookName": "Ground source heat pump",
        "lookupValue": "521",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Water source heat pump",
        "customLookName": "Water source heat pump",
        "lookupValue": "523",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Gas fire, open flue, pre-1980 (open fronted)",
        "customLookName": "Gas fire, open flue, pre-1980 (open fronted)",
        "lookupValue": "601",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Gas fire, open flue, pre-1980 (open fronted), with back boiler unit",
        "customLookName": "Gas fire, open flue, pre-1980 (open fronted), with back boiler unit",
        "lookupValue": "602",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Gas fire, open flue, 1980 or later (open fronted), sitting proud of, and sealed to, fireplace opening",
        "customLookName": "Gas fire, open flue, 1980 or later (open fronted), sitting proud of, and sealed to, fireplace opening",
        "lookupValue": "603",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Gas fire, open flue, 1980 or later (open fronted), sitting proud of, and sealed to, fireplace opening, with back boiler unit",
        "customLookName": "Gas fire, open flue, 1980 or later (open fronted), sitting proud of, and sealed to, fireplace opening, with back boiler unit",
        "lookupValue": "604",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Flush fitting Live Fuel Effect gas fire (open fronted), sealed to fireplace opening",
        "customLookName": "Flush fitting Live Fuel Effect gas fire (open fronted), sealed to fireplace opening",
        "lookupValue": "605",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Flush fitting Live Fuel Effect gas fire (open fronted), sealed to fireplace opening, with back boiler unit",
        "customLookName": "Flush fitting Live Fuel Effect gas fire (open fronted), sealed to fireplace opening, with back boiler unit",
        "lookupValue": "606",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Flush fitting Live Fuel Effect gas fire (open fronted), fan assisted, sealed to fireplace opening",
        "customLookName": "Flush fitting Live Fuel Effect gas fire (open fronted), fan assisted, sealed to fireplace opening",
        "lookupValue": "607",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Gas fire or wall heater, balanced flue",
        "customLookName": "Gas fire or wall heater, balanced flue",
        "lookupValue": "609",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Gas fire, closed fronted, fan assisted",
        "customLookName": "Gas fire, closed fronted, fan assisted",
        "lookupValue": "610",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Condensing gas fire",
        "customLookName": "Condensing gas fire",
        "lookupValue": "611",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Decorative Fuel Effect gas fire, open to chimney",
        "customLookName": "Decorative Fuel Effect gas fire, open to chimney",
        "lookupValue": "612",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Flueless gas fire, secondary heating only",
        "customLookName": "Flueless gas fire, secondary heating only",
        "lookupValue": "613",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Room heater, pre-2000",
        "customLookName": "Room heater, pre-2000",
        "lookupValue": "621",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Room heater, pre-2000, with boiler (no radiators)",
        "customLookName": "Room heater, pre-2000, with boiler (no radiators)",
        "lookupValue": "622",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Room heater, 2000 or later",
        "customLookName": "Room heater, 2000 or later",
        "lookupValue": "623",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Room heater, 2000 or later with boiler (no radiators)",
        "customLookName": "Room heater, 2000 or later with boiler (no radiators)",
        "lookupValue": "624",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Bioethanol heater",
        "customLookName": "Bioethanol heater",
        "lookupValue": "625",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Open fire in grate",
        "customLookName": "Open fire in grate",
        "lookupValue": "631",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Open fire with back boiler (no radiators)",
        "customLookName": "Open fire with back boiler (no radiators)",
        "lookupValue": "632",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Closed room heater",
        "customLookName": "Closed room heater",
        "lookupValue": "633",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Closed room heater with boiler (no radiators)",
        "customLookName": "Closed room heater with boiler (no radiators)",
        "lookupValue": "634",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Stove (pellet-fired)",
        "customLookName": "Stove (pellet-fired)",
        "lookupValue": "635",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Stove (pellet-fired) with boiler (no radiators)",
        "customLookName": "Stove (pellet-fired) with boiler (no radiators)",
        "lookupValue": "636",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Panel, convector or radiator heaters",
        "customLookName": "Panel, convector or radiator heaters",
        "lookupValue": "691",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Portable electric heaters",
        "customLookName": "Portable electric heaters",
        "lookupValue": "693",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Oil-filled radiators",
        "customLookName": "Oil-filled radiators",
        "lookupValue": "694",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingSystem",
        "lookUpItem": "Electric ceiling heating",
        "customLookName": "Electric ceiling heating",
        "lookupValue": "701",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2602 Appliance thermostats",
        "customLookName": "Appliance thermostats",
        "lookupValue": "2602",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2601 No thermostatic control of room temperature, room heater",
        "customLookName": "No thermostatic control of room temperature, room heater",
        "lookupValue": "2601",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2603 Programmer and appliance thermostats",
        "customLookName": "Programmer and appliance thermostats",
        "lookupValue": "2603",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2502 Programmer, no room thermostat",
        "customLookName": "Programmer, no room thermostat",
        "lookupValue": "2502",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2604 Room thermostat only",
        "customLookName": "Room thermostat only",
        "lookupValue": "2604",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2606 Room thermostats only",
        "customLookName": "Room thermostats only",
        "lookupValue": "2606",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2605 Programmer and room thermostats",
        "customLookName": "Programmer and room thermostats",
        "lookupValue": "2605",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2699 None",
        "customLookName": "None",
        "lookupValue": "2699",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2401 Manual charge control",
        "customLookName": "Manual charge control",
        "lookupValue": "2401",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2402 Automatic charge control",
        "customLookName": "Automatic charge control",
        "lookupValue": "2402",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2404 Controls for high heat retention storage heaters",
        "customLookName": "Controls for high heat retention storage heaters",
        "lookupValue": "2404",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2301 Flat rate charging, no thermostatic control of room temperature",
        "customLookName": "Flat rate charging, no thermostatic control of room temperature",
        "lookupValue": "2301",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2302 Flat rate charging, programmer, no room thermostat",
        "customLookName": "Flat rate charging, programmer, no room thermostat",
        "lookupValue": "2302",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2303 Flat rate charging, room thermostat only",
        "customLookName": "Flat rate charging, room thermostat only",
        "lookupValue": "2303",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2304 Flat rate charging, programmer and room thermostat",
        "customLookName": "Flat rate charging, programmer and room thermostat",
        "lookupValue": "2304",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2305 Flat rate charging, programmer and TRVs",
        "customLookName": "Flat rate charging, programmer and TRVs",
        "lookupValue": "2305",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2306 Charging system linked to use of community heating, programmer and TRVs",
        "customLookName": "Charging system linked to use of community heating, programmer and TRVs",
        "lookupValue": "2306",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2307 Flat rate charging, TRVs",
        "customLookName": "Flat rate charging, TRVs",
        "lookupValue": "2307",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2308 Charging system linked to use of community heating, room thermostat only",
        "customLookName": "Charging system linked to use of community heating, room thermostat only",
        "lookupValue": "2308",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2309 Charging system linked to use of community heating, programmer and room thermostat",
        "customLookName": "Charging system linked to use of community heating, programmer and room thermostat",
        "lookupValue": "2309",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2310 Charging system linked to use of community heating, TRVs",
        "customLookName": "Charging system linked to use of community heating, TRVs",
        "lookupValue": "2310",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2311 Flat rate charging, programmer and at least two room thermostats",
        "customLookName": "Flat rate charging, programmer and at least two room thermostats",
        "lookupValue": "2311",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2312 Charging system linked to use of community heating, programmer and at least two room thermostats",
        "customLookName": "Charging system linked to use of community heating, programmer and at least two room thermostats",
        "lookupValue": "2312",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2501 No thermostatic control of room temperature",
        "customLookName": "No thermostatic control of room temperature",
        "lookupValue": "2501",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2505 Programmer and at least two room thermostats",
        "customLookName": "Programmer and at least two room thermostats",
        "lookupValue": "2505",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2504 Programmer and room thermostat",
        "customLookName": "Programmer and room thermostat,",
        "lookupValue": "2504",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2503 Room thermostat only",
        "customLookName": "Room thermostat only",
        "lookupValue": "2503",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2701 No thermostatic control of room temperature",
        "customLookName": "No thermostatic control of room temperature",
        "lookupValue": "2701",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2704 Programmer and room thermostat",
        "customLookName": "Programmer and room thermostat",
        "lookupValue": "2704",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2702 Programmer, no room thermostat",
        "customLookName": "Programmer, no room thermostat",
        "lookupValue": "2702",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2703 Room thermostat only",
        "customLookName": "Room thermostat only",
        "lookupValue": "2703",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2706 Time and temperature zone control",
        "customLookName": "Time and temperature zone control",
        "lookupValue": "2706",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2201 No time or thermostatic control of room temperature",
        "customLookName": "No time or thermostatic control of room temperature",
        "lookupValue": "2201",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2205 Programmer and at least two room thermostats",
        "customLookName": "Programmer and at least two room thermostats",
        "lookupValue": "2205",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2204 Programmer and room thermostat",
        "customLookName": "Programmer and room thermostat",
        "lookupValue": "2204",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2202 Programmer, no room thermostat",
        "customLookName": "Programmer, no room thermostat",
        "lookupValue": "2202",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2206 Programmer, TRVs and bypass",
        "customLookName": "Programmer, TRVs and bypass",
        "lookupValue": "2206",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2203 Room thermostat only",
        "customLookName": "Room thermostat only",
        "lookupValue": "2203",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2101 No time or thermostatic control of room temperature",
        "customLookName": "No time or thermostatic control of room temperature",
        "lookupValue": "2101",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2102 Programmer, no room thermostat",
        "customLookName": "Programmer, no room thermostat",
        "lookupValue": "2102",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2103 Room thermostat only",
        "customLookName": "Room thermostat only",
        "lookupValue": "2103",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2104 Programmer and room thermostat",
        "customLookName": "Programmer and room thermostat",
        "lookupValue": "2104",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2105 Programmer and at least two room thermostats",
        "customLookName": "Programmer and at least two room thermostats",
        "lookupValue": "2105",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2106 Programmer, room thermostat and TRVs",
        "customLookName": "Programmer, room thermostat and TRVs",
        "lookupValue": "2106",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2111 TRVs and bypass",
        "customLookName": "TRVs and bypass",
        "lookupValue": "2111",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2107 Programmer, TRVs and bypass",
        "customLookName": "Programmer, TRVs and bypass",
        "lookupValue": "2107",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2705 Temperature zone control",
        "customLookName": "Temperature zone control",
        "lookupValue": "2705",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2109 Programmer, TRVs and boiler energy manager",
        "customLookName": "Programmer, TRVs and boiler energy manager",
        "lookupValue": "2109",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2110 (TTZC) by arrangement of plumbing and electrical services",
        "customLookName": "(TTZC) by arrangement of plumbing and electrical services",
        "lookupValue": "2110",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2112 Time and temperature zone control by device in database",
        "customLookName": "Time and temperature zone control by device in database",
        "lookupValue": "2112",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2207 (TTZC) by arrangement of plumbing and electrical services",
        "customLookName": "(TTZC) by arrangement of plumbing and electrical services",
        "lookupValue": "2207",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2208 (TTZC) by device in database",
        "customLookName": "(TTZC) by device in database",
        "lookupValue": "2208",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingControls",
        "lookUpItem": "2506 Time and temperature zone control",
        "customLookName": "Time and temperature zone control",
        "lookupValue": "2506",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "EmitterType",
        "lookUpItem": "Radiators",
        "customLookName": "Radiators",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "EmitterType",
        "lookUpItem": "Underfloor",
        "customLookName": "Underfloor",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "EmitterType",
        "lookUpItem": "Fan coil units",
        "customLookName": "Fan coil units",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "Mains Gas",
        "customLookName": "Mains Gas",
        "lookupValue": "26",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "Electricity",
        "customLookName": "Electricity",
        "lookupValue": "29",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "Bulk LPG",
        "customLookName": "Bulk LPG",
        "lookupValue": "27",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "Bottled LPG",
        "customLookName": "Bottled LPG",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "Oil",
        "customLookName": "Oil",
        "lookupValue": "28",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "House coal",
        "customLookName": "House coal",
        "lookupValue": "33",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "Bioethanol",
        "customLookName": "Bioethanol",
        "lookupValue": "19",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "LPG special condition",
        "customLookName": "LPG special condition",
        "lookupValue": "17",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "B30K",
        "customLookName": "B30K",
        "lookupValue": "18",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "Anthracite",
        "customLookName": "Anthracite",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "Wood logs",
        "customLookName": "Wood logs",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "Wood pellets (in bags)",
        "customLookName": "Wood pellets (in bags)",
        "lookupValue": "16",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "Wood chips",
        "customLookName": "Wood chips",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "Duel fuel (mineral + wood)",
        "customLookName": "Duel fuel (mineral + wood)",
        "lookupValue": "9",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingFuel",
        "lookUpItem": "Smokeless coal",
        "customLookName": "Smokeless coal",
        "lookupValue": "15",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Gas fire, open flue, pre-1980 (open fronted)",
        "customLookName": "Gas fire, open flue, pre-1980 (open fronted)",
        "lookupValue": "601",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Gas fire, open flue, pre-1980 (open fronted), with back boiler unit",
        "customLookName": "Gas fire, open flue, pre-1980 (open fronted), with back boiler unit",
        "lookupValue": "602",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Gas fire, open flue, 1980 or later (open fronted), sitting proud of, and sealed to, fireplace opening",
        "customLookName": "Gas fire, open flue, 1980 or later (open fronted), sitting proud of, and sealed to, fireplace opening",
        "lookupValue": "603",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Gas fire, open flue, 1980 or later (open fronted), sitting proud of, and sealed to, fireplace opening, with back boiler",
        "customLookName": "Gas fire, open flue, 1980 or later (open fronted), sitting proud of, and sealed to, fireplace opening, with back boiler",
        "lookupValue": "604",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Flush fitting Live Fuel Effect gas fire (open fronted), sealed to fireplace opening",
        "customLookName": "Flush fitting Live Fuel Effect gas fire (open fronted), sealed to fireplace opening",
        "lookupValue": "605",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Flush fitting Live Fuel Effect gas fire (open fronted), sealed to fireplace opening, with back boiler",
        "customLookName": "Flush fitting Live Fuel Effect gas fire (open fronted), sealed to fireplace opening, with back boiler",
        "lookupValue": "606",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Flush fitting Live Fuel Effect gas fire (open fronted), fan assisted, sealed to fireplace opening",
        "customLookName": "Flush fitting Live Fuel Effect gas fire (open fronted), fan assisted, sealed to fireplace opening",
        "lookupValue": "607",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Gas fire or wall heater, balanced flue",
        "customLookName": "Gas fire or wall heater, balanced flue",
        "lookupValue": "609",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Gas fire, closed fronted, fan assisted",
        "customLookName": "Gas fire, closed fronted, fan assisted",
        "lookupValue": "610",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Condensing gas fire",
        "customLookName": "Condensing gas fire",
        "lookupValue": "611",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Decorative Fuel Effect gas fire, open to chimney",
        "customLookName": "Decorative Fuel Effect gas fire, open to chimney",
        "lookupValue": "612",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Flueless gas fire",
        "customLookName": "Flueless gas fire",
        "lookupValue": "613",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Room heater, pre 2000",
        "customLookName": "Room heater, pre 2000",
        "lookupValue": "621",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Room heater, pre 2000, with boiler (no radiators)",
        "customLookName": "Room heater, pre 2000, with boiler (no radiators)",
        "lookupValue": "622",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Room heater, 2000 or later",
        "customLookName": "Room heater, 2000 or later",
        "lookupValue": "623",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Room heater, 2000 or later with boiler (no radiators)",
        "customLookName": "Room heater, 2000 or later with boiler (no radiators)",
        "lookupValue": "624",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Bioethanol heater, secondary heating only",
        "customLookName": "Bioethanol heater, secondary heating only",
        "lookupValue": "625",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Open fire in grate",
        "customLookName": "Open fire in grate",
        "lookupValue": "631",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Open fire with back boiler (no radiators)",
        "customLookName": "Open fire with back boiler (no radiators)",
        "lookupValue": "632",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Closed room heater",
        "customLookName": "Closed room heater",
        "lookupValue": "633",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Closed room heater with boiler (no radiators)",
        "customLookName": "Closed room heater with boiler (no radiators)",
        "lookupValue": "634",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Stove (pellet fired)",
        "customLookName": "Stove (pellet fired)",
        "lookupValue": "635",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Stove (pellet fired) with boiler (no radiators)",
        "customLookName": "Stove (pellet fired) with boiler (no radiators)",
        "lookupValue": "636",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Panel, convector or radiant heaters",
        "customLookName": "Panel, convector or radiant heaters",
        "lookupValue": "691",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Portable electric heaters",
        "customLookName": "Portable electric heaters",
        "lookupValue": "693",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "SecondaryHeatingSystem",
        "lookUpItem": "Water- or oil-filled radiators",
        "customLookName": "Water- or oil-filled radiators",
        "lookupValue": "694",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "None",
        "customLookName": "None",
        "lookupValue": "999",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "From Main System 1",
        "customLookName": "From Main System 1",
        "lookupValue": "901",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "From Main System 2",
        "customLookName": "From Main System 2",
        "lookupValue": "914",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "From Secondary system",
        "customLookName": "From Secondary system",
        "lookupValue": "902",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Electric immersion",
        "customLookName": "Electric immersion",
        "lookupValue": "903",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Single-point gas water heater (instantaneous at point of use)",
        "customLookName": "Single-point gas water heater (instantaneous at point of use)",
        "lookupValue": "907",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Multi-point gas water heater (instantaneous serving several taps)",
        "customLookName": "Multi-point gas water heater (instantaneous serving several taps)",
        "lookupValue": "908",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Electric instantaneous at point of use",
        "customLookName": "Electric instantaneous at point of use",
        "lookupValue": "909",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Gas boiler/circulator for water heating only",
        "customLookName": "Gas boiler/circulator for water heating only",
        "lookupValue": "911",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Oil boiler/circulator for water heating only",
        "customLookName": "Oil boiler/circulator for water heating only",
        "lookupValue": "912",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Solid fuel boiler/circulator for water heating only",
        "customLookName": "Solid fuel boiler/circulator for water heating only",
        "lookupValue": "913",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Range cooker, gas, single burner, with permanent pilot",
        "customLookName": "Range cooker, gas, single burner, with permanent pilot",
        "lookupValue": "921",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Range cooker, gas, single burner, with automatic ignition",
        "customLookName": "Range cooker, gas, single burner, with automatic ignition",
        "lookupValue": "922",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Range cooker, gas, twin burner, with automatic ignition (pre 1998)",
        "customLookName": "Range cooker, gas, twin burner, with automatic ignition (pre 1998)",
        "lookupValue": "924",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Range cooker, oil, single burner",
        "customLookName": "Range cooker, oil, single burner",
        "lookupValue": "927",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Range cooker, oil, twin burner (pre 1998)",
        "customLookName": "Range cooker, oil, twin burner (pre 1998)",
        "lookupValue": "928",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Range cooker, solid fuel, integral oven and boiler",
        "customLookName": "Range cooker, solid fuel, integral oven and boiler",
        "lookupValue": "930",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Range cooker, solid fuel, independent oven and boiler",
        "customLookName": "Range cooker, solid fuel, independent oven and boiler",
        "lookupValue": "931",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Electric heat pump for water heating only",
        "customLookName": "Electric heat pump for water heating only",
        "lookupValue": "941",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Hot water only community scheme - boilers",
        "customLookName": "Hot water only community scheme - boilers",
        "lookupValue": "950",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Hot water only community scheme - CHP",
        "customLookName": "Hot water only community scheme - CHP",
        "lookupValue": "951",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Hot water only community scheme - heat pump",
        "customLookName": "Hot water only community scheme - heat pump",
        "lookupValue": "952",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "WaterHeatingType",
        "lookUpItem": "Hot water only community scheme - heat network",
        "customLookName": "Hot water only community scheme - heat network",
        "lookupValue": "953",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderSize",
        "lookUpItem": "No access",
        "customLookName": "No access",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderSize",
        "lookUpItem": "No cylinder",
        "customLookName": "No cylinder",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderSize",
        "lookUpItem": "Normal (up to 130 litres)",
        "customLookName": "Normal (up to 130 litres)",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderSize",
        "lookUpItem": "Medium (131-170 litres)",
        "customLookName": "Medium (131-170 litres)",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderSize",
        "lookUpItem": "Large (greater than 170 litres)",
        "customLookName": "Large (greater than 170 litres)",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "CylinderSize",
        "lookUpItem": "From Solar Water Heating",
        "customLookName": "From Solar Water Heating",
        "lookupValue": "5",
    },
    // {
    //     "rdsapVersion": "9.9.4",
    //     "dataItem": "CylinderSize",
    //     "lookUpItem": "Exact cylinder volume known",
    //     "customLookName": "Exact cylinder volume known",
    //     "lookupValue": "6",
    // },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "Basement",
        "customLookName": "Basement",
        "lookupValue": "-1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "Ground Floor",
        "customLookName": "Ground Floor",
        "lookupValue": "00",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "1st Floor",
        "customLookName": "1st Floor",
        "lookupValue": "01",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "2nd Floor",
        "customLookName": "2nd Floor",
        "lookupValue": "02",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "3rd Floor",
        "customLookName": "3rd Floor",
        "lookupValue": "03",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "4th Floor",
        "customLookName": "4th Floor",
        "lookupValue": "04",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "5th Floor",
        "customLookName": "5th Floor",
        "lookupValue": "05",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "6th Floor",
        "customLookName": "6th Floor",
        "lookupValue": "06",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "7th Floor",
        "customLookName": "7th Floor",
        "lookupValue": "07",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "8th Floor",
        "customLookName": "8th Floor",
        "lookupValue": "08",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "9th Floor",
        "customLookName": "9th Floor",
        "lookupValue": "09",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "10th Floor",
        "customLookName": "10th Floor",
        "lookupValue": "10",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "11th Floor",
        "customLookName": "11th Floor",
        "lookupValue": "11",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "12th Floor",
        "customLookName": "12th Floor",
        "lookupValue": "12",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "13th Floor",
        "customLookName": "13th Floor",
        "lookupValue": "13",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "14th Floor",
        "customLookName": "14th Floor",
        "lookupValue": "14",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "15th Floor",
        "customLookName": "15th Floor",
        "lookupValue": "15",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "16th Floor",
        "customLookName": "16th Floor",
        "lookupValue": "16",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "17th Floor",
        "customLookName": "17th Floor",
        "lookupValue": "17",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "18th Floor",
        "customLookName": "18th Floor",
        "lookupValue": "18",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "19th Floor",
        "customLookName": "19th Floor",
        "lookupValue": "19",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "20th Floor",
        "customLookName": "20th Floor",
        "lookupValue": "20",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "FlatLocation",
        "lookUpItem": "21st or above Floor",
        "customLookName": "21st or above Floor",
        "lookupValue": "20+",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1930 - 1949",
        "customLookName": "1930 - 1949",
        "lookupValue": "C",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "2012 onwards",
        "customLookName": "2012 onwards",
        "lookupValue": "L",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "Pre 1900",
        "customLookName": "Pre 1900",
        "lookupValue": "A",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1900 - 1929",
        "customLookName": "1900 - 1929",
        "lookupValue": "B",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1950 - 1966",
        "customLookName": "1950 - 1966",
        "lookupValue": "D",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1967 - 1975",
        "customLookName": "1967 - 1975",
        "lookupValue": "E",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1976 - 1982",
        "customLookName": "1976 - 1982",
        "lookupValue": "F",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1983 - 1990",
        "customLookName": "1983 - 1990",
        "lookupValue": "G",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1991 - 1995",
        "customLookName": "1991 - 1995",
        "lookupValue": "H",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1996 - 2002",
        "customLookName": "1996 - 2002",
        "lookupValue": "I",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "2003 - 2006",
        "customLookName": "2003 - 2006",
        "lookupValue": "J",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "2007 - 2011",
        "customLookName": "2007 - 2011",
        "lookupValue": "K",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "Pre 1919",
        "customLookName": "Pre 1919",
        "lookupValue": "A",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1919 - 1929",
        "customLookName": "1919 - 1929",
        "lookupValue": "B",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1950 - 1964",
        "customLookName": "1950 - 1964",
        "lookupValue": "D",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1965 - 1975",
        "customLookName": "1965 - 1975",
        "lookupValue": "E",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1976 - 1983",
        "customLookName": "1976 - 1983",
        "lookupValue": "F",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1984 - 1991",
        "customLookName": "1984 - 1991",
        "lookupValue": "G",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1992 - 1998",
        "customLookName": "1992 - 1998",
        "lookupValue": "H",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1999 - 2002",
        "customLookName": "1999 - 2002",
        "lookupValue": "I",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "2003 - 2007",
        "customLookName": "2003 - 2007",
        "lookupValue": "J",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "2008 - 2011",
        "customLookName": "2008 - 2011",
        "lookupValue": "K",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1950 - 1973",
        "customLookName": "1950 - 1973",
        "lookupValue": "D",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1974 - 1977",
        "customLookName": "1950 - 1973",
        "lookupValue": "E",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1978 - 1985",
        "customLookName": "1978 - 1985",
        "lookupValue": "F",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1986 - 1991",
        "customLookName": "1986 - 1991",
        "lookupValue": "G",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "1992 - 1999",
        "customLookName": "1992 - 1999",
        "lookupValue": "H",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "2000 - 2006",
        "customLookName": "2000 - 2006",
        "lookupValue": "I",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "not applicable",
        "customLookName": "not applicable",
        "lookupValue": "J",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "2007 - 2013",
        "customLookName": "2007 - 2013",
        "lookupValue": "K",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ConstructionAge",
        "lookUpItem": "2014 onwards",
        "customLookName": "2014 onwards",
        "lookupValue": "L",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Glazing Type",
        "lookUpItem": "Double glazed (before 2003)",
        "customLookName": "Double glazed (before 2003)",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Glazing Type",
        "lookUpItem": "Double glazed (2003 or later)",
        "customLookName": "Double glazed (2003 or later)",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "EPC has expired",
        "customLookName": "EPC has expired",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "Building has changed since the last EPC",
        "customLookName": "Building has changed since the last EPC",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "Assessor instructed to produce a new EPC",
        "customLookName": "Assessor instructed to produce a new EPC",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "Duplicate EPC",
        "customLookName": "Duplicate EPC",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "Replacement for 'not for issue' EPC",
        "customLookName": "Replacement for 'not for issue' EPC",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "Replacement for any other status EPC",
        "customLookName": "Replacement for any other status EPC",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "Green Deal: existing EPC pre-dates 1 April 2012",
        "customLookName": "Green Deal: existing EPC pre-dates 1 April 2012",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "Green Deal: previous EPC is inaccurate",
        "customLookName": "Green Deal: previous EPC is inaccurate",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "RHI: EPC is more than 24 months old",
        "customLookName": "RHI: EPC is more than 24 months old",
        "lookupValue": "9",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "Feed In Tariff",
        "customLookName": "Feed In Tariff",
        "lookupValue": "10",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "Rental Purposes",
        "customLookName": "Rental Purposes",
        "lookupValue": "11",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "ECO scheme",
        "customLookName": "ECO scheme",
        "lookupValue": "12",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "ECO scheme innovation",
        "customLookName": "ECO scheme innovation",
        "lookupValue": "13",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Reason",
        "lookUpItem": "ECO First Time Central Heating",
        "customLookName": "ECO First Time Central Heating",
        "lookupValue": "14",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Exists",
        "lookUpItem": "Yes",
        "customLookName": "Yes",
        "lookupValue": "Y",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Exists",
        "lookUpItem": "No",
        "customLookName": "No",
        "lookupValue": "N",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Previous EPC Exists",
        "lookUpItem": "Not Recorded",
        "customLookName": "Not Recorded",
        "lookupValue": "NR",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Related Party Disclosure",
        "lookUpItem": "No related party",
        "customLookName": "No related party",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Related Party Disclosure",
        "lookUpItem": "Relative of homeowner or of occupier of the property",
        "customLookName": "Relative of homeowner or of occupier of the property",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Related Party Disclosure",
        "lookUpItem": "Residing at the property",
        "customLookName": "Residing at the property",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Related Party Disclosure",
        "lookUpItem": "Financial interest in the property",
        "customLookName": "Financial interest in the property",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Related Party Disclosure",
        "lookUpItem": "Owner or Director of the organisation dealing with the property transaction",
        "customLookName": "Owner or Director of the organisation dealing with the property transaction",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Related Party Disclosure",
        "lookUpItem": "Employed by the professional dealing with the property transaction",
        "customLookName": "Employed by the professional dealing with the property transaction",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "Related Party Disclosure",
        "lookUpItem": "Relative of the professional dealing with the property transaction",
        "customLookName": "Relative of the professional dealing with the property transaction",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingBoilerIgnition",
        "lookUpItem": "Auto-ignition",
        "customLookName": "Auto-ignition",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingBoilerIgnition",
        "lookUpItem": "Permanent pilot light",
        "customLookName": "Permanent pilot light",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "showerOutletType",
        "lookUpItem": "Unknown – for backward compatibility only, do not use",
        "customLookName": "Unknown – for backward compatibility only, do not use",
        "lookupValue": "0",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "showerOutletType",
        "lookUpItem": "Non-electric shower(s) only",
        "customLookName": "Non-electric shower(s) only",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "showerOutletType",
        "lookUpItem": "Electric shower(s) only",
        "customLookName": "Electric shower(s) only",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "showerOutletType",
        "lookUpItem": "Both electric and non-electric showers",
        "customLookName": "Both electric and non-electric showers",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "showerOutletType",
        "lookUpItem": "No shower",
        "customLookName": "No shower",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "showerWWHRS",
        "lookUpItem": "None",
        "customLookName": "None",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "showerWWHRS",
        "lookUpItem": "WWHR1",
        "customLookName": "WWHR1",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "showerWWHRS",
        "lookUpItem": "WWHR2",
        "customLookName": "WWHR2",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "showerWWHRS",
        "lookUpItem": "Storage WWHR",
        "customLookName": "Storage WWHR",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "wallMeasuredInsulationLambda",
        "lookUpItem": "0.04",
        "customLookName": "0.04",
        "lookupValue": "0.04",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "wallMeasuredInsulationLambda",
        "lookUpItem": "0.03",
        "customLookName": "0.03",
        "lookupValue": "0.03",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "wallMeasuredInsulationLambda",
        "lookUpItem": "0.025",
        "customLookName": "0.025",
        "lookupValue": "0.025",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvPitch",
        "lookUpItem": "horizontal",
        "customLookName": "horizontal",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvPitch",
        "lookUpItem": "30 degrees",
        "customLookName": "30 degrees",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvPitch",
        "lookUpItem": "45 degrees",
        "customLookName": "45 degrees",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvPitch",
        "lookUpItem": "60 degrees",
        "customLookName": "60 degrees",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvPitch",
        "lookUpItem": "vertical",
        "customLookName": "vertical",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOrientation",
        "lookUpItem": "North",
        "customLookName": "North",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOrientation",
        "lookUpItem": "North East",
        "customLookName": "North East",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOrientation",
        "lookUpItem": "East",
        "customLookName": "East",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOrientation",
        "lookUpItem": "South East",
        "customLookName": "South East",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOrientation",
        "lookUpItem": "South",
        "customLookName": "South",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOrientation",
        "lookUpItem": "South West",
        "customLookName": "South West",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOrientation",
        "lookUpItem": "West",
        "customLookName": "West",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOrientation",
        "lookUpItem": "North West",
        "customLookName": "North West",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOrientation",
        "lookUpItem": "To be used when the pitch is horizontal",
        "customLookName": "To be used when the pitch is horizontal",
        "lookupValue": "9",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOvershading",
        "lookUpItem": "none or very little",
        "customLookName": "none or very little",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOvershading",
        "lookUpItem": "modest",
        "customLookName": "modest",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOvershading",
        "lookUpItem": "significant",
        "customLookName": "significant",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOvershading",
        "lookUpItem": "heavy",
        "customLookName": "heavy",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem1PvOvershading",
        "lookUpItem": "severe",
        "customLookName": "severe",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvPitch",
        "lookUpItem": "horizontal",
        "customLookName": "horizontal",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvPitch",
        "lookUpItem": "30 degrees",
        "customLookName": "30 degrees",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvPitch",
        "lookUpItem": "45 degrees",
        "customLookName": "45 degrees",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvPitch",
        "lookUpItem": "60 degrees",
        "customLookName": "60 degrees",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvPitch",
        "lookUpItem": "vertical",
        "customLookName": "vertical",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOrientation",
        "lookUpItem": "North",
        "customLookName": "North",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOrientation",
        "lookUpItem": "North East",
        "customLookName": "North East",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOrientation",
        "lookUpItem": "East",
        "customLookName": "East",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOrientation",
        "lookUpItem": "South East",
        "customLookName": "South East",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOrientation",
        "lookUpItem": "South",
        "customLookName": "South",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOrientation",
        "lookUpItem": "South West",
        "customLookName": "South West",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOrientation",
        "lookUpItem": "West",
        "customLookName": "West",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOrientation",
        "lookUpItem": "North West",
        "customLookName": "North West",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOrientation",
        "lookUpItem": "To be used when the pitch is horizontal",
        "customLookName": "To be used when the pitch is horizontal",
        "lookupValue": "ND",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOvershading",
        "lookUpItem": "none or very little",
        "customLookName": "none or very little",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOvershading",
        "lookUpItem": "modest",
        "customLookName": "modest",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOvershading",
        "lookUpItem": "significant",
        "customLookName": "significant",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOvershading",
        "lookUpItem": "heavy",
        "customLookName": "heavy",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "fghrsHeatingSystem2PvOvershading",
        "lookUpItem": "severe",
        "customLookName": "severe",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "To be used only when there is no heating/hot-water system or data is from a community network",
        "customLookName": "None or Community Network",
        "lookupValue": "0"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "mains gas - this is for backwards compatibility only and should not be used",
        "customLookName": "Mains Gas - Deprecated",
        "lookupValue": "1"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "LPG - this is for backwards compatibility only and should not be used",
        "customLookName": "LPG - Deprecated",
        "lookupValue": "2"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "bottled LPG",
        "customLookName": "Bottled LPG",
        "lookupValue": "3"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "oil - this is for backwards compatibility only and should not be used",
        "customLookName": "Oil - Deprecated",
        "lookupValue": "4"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "anthracite",
        "customLookName": "Anthracite",
        "lookupValue": "5"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "wood logs",
        "customLookName": "Wood Logs",
        "lookupValue": "6"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "bulk wood pellets",
        "customLookName": "Bulk Wood Pellets",
        "lookupValue": "7"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "wood chips",
        "customLookName": "Wood Chips",
        "lookupValue": "8"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "dual fuel - mineral + wood",
        "customLookName": "Dual Fuel - Mineral + Wood",
        "lookupValue": "9"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "electricity - this is for backwards compatibility only and should not be used",
        "customLookName": "Electricity - Deprecated",
        "lookupValue": "10"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "waste combustion - this is for backwards compatibility only and should not be used",
        "customLookName": "Waste Combustion - Deprecated",
        "lookupValue": "11"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "biomass - this is for backwards compatibility only and should not be used",
        "customLookName": "Biomass - Deprecated",
        "lookupValue": "12"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "biogas - landfill - this is for backwards compatibility only and should not be used",
        "customLookName": "Biogas Landfill - Deprecated",
        "lookupValue": "13"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "house coal - this is for backwards compatibility only and should not be used",
        "customLookName": "House Coal - Deprecated",
        "lookupValue": "14"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "smokeless coal",
        "customLookName": "Smokeless Coal",
        "lookupValue": "15"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "wood pellets in bags for secondary heating",
        "customLookName": "Wood Pellets for Secondary Heating",
        "lookupValue": "16"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "LPG special condition",
        "customLookName": "LPG Special Condition",
        "lookupValue": "17"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "B30K (not community)",
        "customLookName": "B30K Not Community",
        "lookupValue": "18"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "bioethanol",
        "customLookName": "Bioethanol",
        "lookupValue": "19"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "mains gas (community)",
        "customLookName": "Mains Gas Community",
        "lookupValue": "20"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "LPG (community)",
        "customLookName": "LPG Community",
        "lookupValue": "21"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "oil (community)",
        "customLookName": "Oil Community",
        "lookupValue": "22"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "B30D (community)",
        "customLookName": "B30D Community",
        "lookupValue": "23"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "coal (community)",
        "customLookName": "Coal Community",
        "lookupValue": "24"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "electricity (community)",
        "customLookName": "Electricity Community",
        "lookupValue": "25"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "mains gas (not community)",
        "customLookName": "Mains Gas Non-Community",
        "lookupValue": "26"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "LPG (not community)",
        "customLookName": "LPG Non-Community",
        "lookupValue": "27"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "oil (not community)",
        "customLookName": "Oil Non-Community",
        "lookupValue": "28"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "electricity (not community)",
        "customLookName": "Electricity Non-Community",
        "lookupValue": "29"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "waste combustion (community)",
        "customLookName": "Waste Combustion Community",
        "lookupValue": "30"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "biomass (community)",
        "customLookName": "Biomass Community",
        "lookupValue": "31"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "biogas (community)",
        "customLookName": "Biogas Community",
        "lookupValue": "32"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "house coal (not community)",
        "customLookName": "House Coal Non-Community",
        "lookupValue": "33"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "biodiesel from any biomass source",
        "customLookName": "Biodiesel from Any Biomass",
        "lookupValue": "34"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "biodiesel from used cooking oil only",
        "customLookName": "Biodiesel from Used Cooking Oil",
        "lookupValue": "35"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "biodiesel from vegetable oil only (not community)",
        "customLookName": "Biodiesel from Vegetable Oil (Non-Community)",
        "lookupValue": "36"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "appliances able to use mineral oil or liquid biofuel",
        "customLookName": "Appliances for Mineral Oil or Liquid Biofuel",
        "lookupValue": "37"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "biogas (not community)",
        "customLookName": "Biogas - Non-Community",
        "lookupValue": "51"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "heat from boilers that can use mineral oil or biodiesel (community)",
        "customLookName": "Heat from Boilers for Mineral Oil or Biodiesel (Community)",
        "lookupValue": "56"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "heat from boilers using biodiesel from any biomass source (community)",
        "customLookName": "Heat from Boilers using Biodiesel from Biomass (Community)",
        "lookupValue": "57"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "biodiesel from vegetable oil only (community)",
        "customLookName": "Biodiesel from Vegetable Oil (Community)",
        "lookupValue": "58"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "HeatingFuelTypeCode",
        "lookUpItem": "from heat network data (community)",
        "customLookName": "From Heat Network Data (Community)",
        "lookupValue": "99"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "roofRoomsType",
        "lookUpItem": "Type 1",
        "customLookName": "Type 1",
        "lookupValue": "1"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "roofRoomsType",
        "lookUpItem": "Type 2",
        "customLookName": "Type 2",
        "lookupValue": "2"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "gableWall1Type",
        "lookUpItem": "exposed",
        "customLookName": "exposed",
        "lookupValue": "0"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "gableWall1Type",
        "lookUpItem": "party",
        "customLookName": "party",
        "lookupValue": "1"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "gableWall1Type",
        "lookUpItem": "sheltered",
        "customLookName": "sheltered",
        "lookupValue": "2"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "gableWall2Type",
        "lookUpItem": "exposed",
        "customLookName": "exposed",
        "lookupValue": "0"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "gableWall2Type",
        "lookUpItem": "party",
        "customLookName": "party",
        "lookupValue": "1"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "gableWall2Type",
        "lookUpItem": "sheltered",
        "customLookName": "sheltered",
        "lookupValue": "2"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": " openingWallLocation",
        "lookUpItem": "External wall type 1",
        "customLookName": "External wall type 1",
        "lookupValue": "1"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": " openingWallLocation",
        "lookUpItem": "Alternative wall 1",
        "customLookName": "Alternative wall 1",
        "lookupValue": "2"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": " openingWallLocation",
        "lookUpItem": "Alternative wall 2",
        "customLookName": "Alternative wall 2",
        "lookupValue": "3"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": " openingWallLocation",
        "lookUpItem": "Roof of Room in Roof",
        "customLookName": "Roof of Room in Roof",
        "lookupValue": "4"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": " openingWallLocation",
        "lookUpItem": "gable wall 1.",
        "customLookName": "gable wall 1.",
        "lookupValue": "5"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": " openingWallLocation",
        "lookUpItem": "gable wall 2.",
        "customLookName": "gable wall 2.",
        "lookupValue": "6"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": " openingWallLocation",
        "lookUpItem": "common wall 1 Only include for RR Type 2.",
        "customLookName": "common wall 1 Only include for RR Type 2.",
        "lookupValue": "7"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": " openingWallLocation",
        "lookUpItem": "common wall 2 Only include for RR Type 2.",
        "customLookName": "common wall 2 Only include for RR Type 2.",
        "lookupValue": "8"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": " openingInsulatedShuttersPresent",
        "lookUpItem": "Yes",
        "customLookName": "Yes",
        "lookupValue": "Y"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": " openingInsulatedShuttersPresent",
        "lookUpItem": "No",
        "customLookName": "No",
        "lookupValue": "N"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": " openingShuttersPresent",
        "lookUpItem": "Yes",
        "customLookName": "Yes",
        "lookupValue": "Y"
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": " openingShuttersPresent",
        "lookUpItem": "No",
        "customLookName": "No",
        "lookupValue": "N"
    },

    {
        "rdsapVersion": "9.9.4",
        "dataItem": "AddendaToEPC",
        "lookUpItem": "1. Wall type does not correspond to options available in RdSAP",
        "customLookName": "Non-standard wall type",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "AddendaToEPC",
        "lookUpItem": "4. Dwelling has a swimming pool",
        "customLookName": "Swimming pool",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "AddendaToEPC",
        "lookUpItem": "5. Dwelling has micro-CHP not found in database",
        "customLookName": "Micro-CHP not in database",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "AddendaToEPC",
        "lookUpItem": "6. Storage heater immersion, and single electric meter",
        "customLookName": "Storage heater immersion",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "AddendaToEPC",
        "lookUpItem": "8. PVs or wind turbine present on the property (England, Wales or Scotland)",
        "customLookName": "PVs or wind turbine present",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "AddendaToEPC",
        "lookUpItem": "9. Two main heating systems and heating system upgrade is recommended",
        "customLookName": "Two main heating systems",
        "lookupValue": "9",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "AddendaToEPC",
        "lookUpItem": "10. Dual electricity meter selected but there is also an electricity meter for standard tariff",
        "customLookName": "Dual electricity meter",
        "lookupValue": "10",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "AddendaToEPC",
        "lookUpItem": "11. Single electricity meter selected but there is also an electricity meter for an off-peak tariff",
        "customLookName": "Single electricity meter for off-peak",
        "lookupValue": "11",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "AddendaToEPC",
        "lookUpItem": "12. Dwelling is using a biomass fuel that is not in the RdSAP fuel options",
        "customLookName": "Biomass fuel not in RdSAP options",
        "lookupValue": "12",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "AddendaToEPC",
        "lookUpItem": "14. Dwelling has a special energy saving feature",
        "customLookName": "Special energy saving feature",
        "lookupValue": "14",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "EPC has expired",
        "customLookName": "EPC has expired",
        "lookupValue": "1",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "Building fabric and/or services has changed since the last EPC assessment and a new EPC has been commissioned for that building",
        "customLookName": "Building fabric and/or services has changed since the last EPC assessment and a new EPC has been commissioned for that building",
        "lookupValue": "2",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "Assessor instructed to produce a new EPC upon request from building owner/tenant/landlord after confirming to the requestor that a valid EPC already exists",
        "customLookName": "Assessor instructed to produce a new EPC upon request from building owner/tenant/landlord after confirming to the requestor that a valid EPC already exists",
        "lookupValue": "3",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "Duplicate EPC produced in systematic or human error",
        "customLookName": "Duplicate EPC produced in systematic or human error",
        "lookupValue": "4",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "Replacement of an erroneous EPC where the original EPC has been marked not for issue",
        "customLookName": "Replacement of an erroneous EPC where the original EPC has been marked not for issue",
        "lookupValue": "5",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "Replacement of an erroneous EPC where the original EPC has not been marked not for issue",
        "customLookName": "Replacement of an erroneous EPC where the original EPC has not been marked not for issue",
        "lookupValue": "6",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "Green Deal Advice Report: existing EPC pre-dates 1 April 2012",
        "customLookName": "Green Deal Advice Report: existing EPC pre-dates 1 April 2012",
        "lookupValue": "7",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "Green Deal Advice Report: previous EPC is inaccurate",
        "customLookName": "Green Deal Advice Report: previous EPC is inaccurate",
        "lookupValue": "8",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "Renewable Heat Incentive (RHI): existing EPC is more than 24 months old on the date of RHI application",
        "customLookName": "Renewable Heat Incentive (RHI): existing EPC is more than 24 months old on the date of RHI application",
        "lookupValue": "9",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "Feed-In-Tariff: householder has chosen to undertake energy efficiency measures to improve the previous EPC rating before installing solar panels and applying for FITs",
        "customLookName": "Feed-In-Tariff: householder has chosen to undertake energy efficiency measures to improve the previous EPC rating before installing solar panels and applying for FITs",
        "lookupValue": "10",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "Existing EPC is more than 10 years old or is below an E rating",
        "customLookName": "Existing EPC is more than 10 years old or is below an E rating",
        "lookupValue": "11",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "A valid EPC is required to demonstrate that the building has an EPC rating of E, F or G to determine if the householder is eligible for Energy Company Obligation scheme measures",
        "customLookName": "A valid EPC is required to demonstrate that the building has an EPC rating of E, F or G to determine if the householder is eligible for Energy Company Obligation scheme measures",
        "lookupValue": "12",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "A valid EPC is required to demonstrate that the building has an EPC rating of D to determine if the householder is eligible for Energy Company Obligation scheme innovation measures",
        "customLookName": "A valid EPC is required to demonstrate that the building has an EPC rating of D to determine if the householder is eligible for Energy Company Obligation scheme innovation measures",
        "lookupValue": "13",
    },
    {
        "rdsapVersion": "9.9.4",
        "dataItem": "ForInformationOnly",
        "lookUpItem": "A valid EPC is required to demonstrate that the building has an EPC rating of E, F or G to determine if the social housing tenant is eligible for the Energy Company Obligation scheme First Time Central Heating measures",
        "customLookName": "A valid EPC is required to demonstrate that the building has an EPC rating of E, F or G to determine if the social housing tenant is eligible for the Energy Company Obligation scheme First Time Central Heating measures",
        "lookupValue": "14",
    }

]
